import { GoogleMapsModule } from '@angular/google-maps';
import { Component, HostListener, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { DetalhesImovelComponent } from './detalhes-imovel/detalhes-imovel.component';
import { MatDialog } from '@angular/material/dialog';
import { IntegracaoService } from '../services/integracao.service';
import { BairrosDisponiveisFiltro, BairrosDisponiveisResponse, CidadesDisponiveisFiltro, CidadesDisponiveisResponse, ImoveisDisponiveisFiltro, ImoveisDisponiveisResponse, ImovelDetalhes, TiposImoveisPorDestinacaoResponse, TiposImoveisResponse } from '../model/integracao';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BehaviorSubject, Observable, Subject, Subscription, debounceTime, distinctUntilChanged, filter, map, of, startWith, switchMap } from 'rxjs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';
import { IMOVEIS_CALCADAO, IMOVEIS_MIL_AREA_MILITAR, IMOVEIS_MIL_COLEGIO, IMOVEIS_MIL_HOSPITAL, IMOVEIS_MIL_VERDE_QUART, IMOVEIS_UFN, IMOVEIS_UFSM } from '../model/listaImoveis';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { UtilService } from '../services/util.service';
import { BuscaAvancadaFilter } from '../model/busca-avancada-filter.model';
import { Pagination } from '../model/pagination.model';
import { BuscaService, FetchResponse } from '../services/busca.service';
import { ImovelResponseDto } from '../dto/imovel-response.dto';
import { EnderecoImovelPipe } from '../pipes/endereco-imovel.pipe';
import { parseOrUndefined } from '../util';
import { LoaderComponent } from '../components/loader/loeader.component';
import { buildMapCardHTML, resetBuscaAvancadaFilter } from './busca.util';
import { MatIconModule } from '@angular/material/icon';
import { DeveExibirAtributoPipe } from '../pipes/deve-exibir-atributo';
import { CorretorBioComponent } from "../components/corretor-bio/corretor-bio.component";
import { SwiperImagensComponent } from '../components/swiper-imagens/swiper-imagens.component';
//import { GoogleMapsLoaderService } from './google-maps-loader.service';
declare const google: any;

@Component({
   standalone: true,
   imports: [
      CommonModule,
      MatButtonModule,
      MatIconModule,
      GoogleMapsModule,
      FormsModule,
      ReactiveFormsModule,
      MatFormFieldModule,
      MatInputModule,
      MatAutocompleteModule,
      MatOptionModule,
      NgxMaskDirective,
      EnderecoImovelPipe,
      LoaderComponent,
      DeveExibirAtributoPipe,
      CorretorBioComponent,
      SwiperImagensComponent
   ],
   selector: 'app-busca',
   templateUrl: './busca.component.html',
   styleUrls: ['./busca.component.scss'],
   providers: [provideNgxMask()]
})
export class BuscaComponent implements OnInit {
   public codigoCaptador: number;
   private subscriptions: Subscription[] = [];
   public buscaAvancadaFilter?: BuscaAvancadaFilter;
   public sort: any = 'd_date';
   public imoveis2: ImovelResponseDto[] = [];
   public message: string | null = null;
   public quantidade2: number = 0;

   public subTipos: { name: string; checked: boolean }[] = [];
   public tags: { name: string; value: string }[] = [];
   public caracteristicas: { name: string; checked: boolean }[] = [];

   public isLoading: boolean = false;

   public tiposImoveis: TiposImoveisResponse[] = [];
   public tiposImoveisFiltrados: TiposImoveisResponse[] = [];
   public buscaResponse: FetchResponse;
   public selectedTiposImoveis: any = null;
   public selectedTiposImoveisDisponiveisPorDestinacao: any = null;

   // 🔹 Filtros e Seleções
   public searchCod: string = '';
   public codigoTipo: string = '';
   public searchTextBairro: string = '';
   public selectedListaTag: string = '';

   // 🔹 Listas de Seleção
   public selectedTipos: number[] = [];
   public selectedTiposNomes: string[] = [];

   public tips: string[] = [];
   private searchSubject = new Subject<string>();

   hideOnProduciton: boolean = false;

   private marcadores: any[] = [];

   constructor(
      public dialog: MatDialog,
      private router: Router,
      private route: ActivatedRoute,
      private utilService: UtilService,
      private buscaService: BuscaService,
      @Inject(PLATFORM_ID) private platformId: Object
   ) {}

   private apiKey = 'AIzaSyCih4iTaq5A2XMnkCxuKFAfbJUPeOvKp28'; // 🔹 Substitua pela sua chave real
   private map!: any;

   // Variáveis de filtro
   selectedBanheiros: string | null = null;
   selectedVagas: string | null = null;
   selectedValor: string | null = null;
   selectedQuartos: string | null = null;
   selectedSuites: string | null = null;
   selectedMetragem: string | null = null;
   selectedFinalidade: number | null = 1;
   valorMinimo: string | null = '';
   valorMaximo: string | null = '';
   areaDe: number | null = null;
   areaAte: number | null = null;
   selectedOrdenacao: string | null = '';
   selectedCodigoCidade = 0;
   selectedCodigoRegiao = 0;
   selectedCodigoSubRegiao = 0;
   selectedCodigosImoveis = '';
   selectedFinanciamento: boolean | null = null;
   selectedMobiliado: boolean | null = null;

   selectedBairros: string[] = [];
   selectedBairrosNomes: string[] = [];
   filteredBairros: any[] = [];
   BairrosDisponiveis: any[] = [];

   displayFn(tip: string): string {
      return tip ? tip : '';
   }

   ngOnDestroy() {
      this.subscriptions.forEach((sub) => sub.unsubscribe());
   }

   ngOnInit(): void {
      this.codigoCaptador = Number(this.route.snapshot.paramMap.get('idC'));
      console.log({ c: this.codigoCaptador });
      this.isOverlayOpen = false;
      if (isPlatformBrowser(this.platformId)) {
         this.checkMobile();
         if (typeof window !== 'undefined') {
            window.addEventListener('resize', this.checkMobile.bind(this));
         }

         // 🔹 Garante que o scroll acontece depois da renderização
         setTimeout(() => {
            window.scrollTo(0, 0);
         });

         // 🔹 Faz o scroll ao navegar entre páginas
         this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
               setTimeout(() => {
                  window.scrollTo(0, 0);
               });
            }
         });
      }

      if (this.selectedTiposImoveis != '') {
         this.selectedTipos = this.selectedTiposImoveis;
      }

      this.filteredBairros = this.utilService.fetchBairros().map((bairro, index) => ({ nome: bairro, codigo: index }));

      this.BairrosDisponiveis = this.utilService
         .fetchBairros()
         .map((bairro, index) => ({ nome: bairro, codigo: index }));

      console.log({ f: this.filteredBairros, t: this.BairrosDisponiveis });

      this.subTipos = this.utilService.fetchSubtipos().map((subtipo: string) => ({
         name: subtipo,
         checked: false
      }));

      this.tags = this.utilService.fetchTags();

      const routeSubscription = this.route.queryParams.subscribe((params) => this.processSearchParams(params));
      this.subscriptions.push(routeSubscription);

      const sub2 = this.searchSubject
         .pipe(
            debounceTime(300),
            distinctUntilChanged(),
            filter((keywords) => keywords && keywords.trim().length >= 3),
            switchMap((keywords) => this.buscaService.fetchTips({ contrato: this.selectedFinalidade, keywords }))
         )
         .subscribe({
            next: (result: string[]) => {
               this.tips = result;
            },
            error: () => (this.tips = [])
         });

      this.subscriptions.push(sub2);
   }

   async processSearchParams(queryParams: any) {
      if (queryParams?.location) {
         this.buscaAvancadaFilter = await this.utilService.oldSiteParamToBuscaAvancadaFilter(queryParams);
      } else {
         this.buscaAvancadaFilter = { ...queryParams };
      }

      this.sort = this.buscaAvancadaFilter?.sortby ?? 'd_date';
      this.buscarImoveis();
      this.preencherCampos();
   }

   async preencherCampos() {
      const filtro = this.buscaAvancadaFilter;

      this.selectedFinalidade = this.buscaAvancadaFilter.contrato === 'Compra' ? 2 : 1;
      //keywords
      this.searchTextBairro = filtro.keywords ?? undefined;

      if (filtro.codigos) {
         if (!Array.isArray(filtro.codigos)) {
            filtro.codigos = [filtro.codigos];
         }
         this.searchCod = filtro.codigos.join(',');
         this.isCodigo = true;
      } else {
         this.searchCod = '';
         this.isCodigo = false;
      }

      //subtipos = categorias
      if (filtro.subtipo && typeof filtro.subtipo === 'string') {
         filtro.subtipo = [filtro.subtipo];
      }
      const subtipos = filtro.subtipo ?? [];

      subtipos.forEach((subtipos) => {
         this.subTipos.find((sub) => sub.name.toLocaleLowerCase() === subtipos.toLocaleLowerCase()).checked = true;
      });
      this.updateSubtipoString();

      //ordenação
      const op = this.opcoesOrdenacao.find((d) => d.lista === this.sort);
      this.selectedOrdenacao = op.lista;

      //area
      this.areaDe = filtro['area.gte'] != null ? filtro['area.gte'] : undefined;
      this.areaAte = filtro['area.lte'] != null ? filtro['area.lte'] : undefined;

      //valor
      const tipo = this.contratoIsCompra ? 'compra' : 'aluguel';
      this.valorMinimo = filtro[`${tipo}.gte`] != null ? String(filtro[`${tipo}.gte`]) : '';
      this.valorMaximo = filtro[`${tipo}.lte`] != null ? String(filtro[`${tipo}.lte`]) : '';

      //dormitorios
      this.dormitorios =
         this.buscaAvancadaFilter.quartos?.length > 0 ? Number.parseInt(this.buscaAvancadaFilter.quartos[0]) : 0;

      //atualizar garagem
      this.vagas = this.buscaAvancadaFilter['garagem.gte'] ?? 0;

      this.banheiros = filtro['banheiro.gte'] ?? 0;
      this.suites = filtro['suites'] ?? 0;

      this.selectedVagas = this.vagas.toString();

      if (filtro.mobilia !== undefined) {
         const valor = Array.isArray(filtro.mobilia) ? filtro.mobilia[0] : filtro.mobilia;
         this.selectedMobiliado = valor == 1;
      }

      if (filtro.financiavel !== undefined) {
         this.selectedFinanciamento = filtro.financiavel == '1' ? true : false;
      }

      if (filtro.tags && typeof filtro.tags === 'string') {
         this.selectedListaTag = filtro.tags;
      } else if (filtro.tags && Array.isArray(filtro.tags)) {
         this.selectedListaTag = filtro.tags[0];
      } else {
         this.selectedListaTag = '';
      }

      const todasCaracteristicas = this.utilService.fetchCaracteristicas();
      let comodidades = filtro.comodidades ?? [];
      if (comodidades && !Array.isArray(comodidades)) {
         comodidades = [comodidades]; // transforma em array se for string
      }

      this.caracteristicas = todasCaracteristicas.map((caracteristica) => ({
         name: caracteristica,
         checked: comodidades ? comodidades.includes(caracteristica) : false
      }));

      this.preencherBairros();

      this.updateselectedCaracteristicas();
   }

   preencherBairros() {
      const filtro = this.buscaAvancadaFilter;

      if (filtro.bairros) {
         if (typeof filtro.bairros === 'string') {
            this.selectedBairrosNomes = [filtro.bairros];
         } else {
            this.selectedBairrosNomes = filtro.bairros.slice();
         }
      }
   }

   buscarImoveisFiltro(hideMenu: boolean = false) {
      if (this.searchCod) {
         const codigos: string[] = this.searchCod
            .split(',')
            .map((i) => i.trim())
            .filter((i) => i !== '');

         if (codigos.length > 1) {
            this.buscaPorCodigos();
            return;
         }
      }

      this.buscaAvancadaFilter.page = 1;

      this.buscaAvancadaFilter.contrato = this.selectedFinalidade === 2 ? 'Compra' : 'Locação';

      //keywords
      this.buscaAvancadaFilter.keywords = this.searchTextBairro;
      //subtipos
      this.buscaAvancadaFilter.subtipo = this.selectedTiposNomes;
      //area
      this.buscaAvancadaFilter['area.gte'] = this.areaDe > 0 ? this.areaDe : undefined;
      this.buscaAvancadaFilter['area.lte'] = this.areaAte > 0 ? this.areaAte : undefined;

      //valor
      const tipo = this.contratoIsCompra ? 'compra' : 'aluguel';
      this.buscaAvancadaFilter[`${tipo}.gte`] = this.temValor ? parseOrUndefined(this.valorMinimo) : undefined;
      this.buscaAvancadaFilter[`${tipo}.lte`] = this.temValor ? parseOrUndefined(this.valorMaximo) : undefined;

      //dormitorios
      const temDormitorios = this.dormitorios && this.dormitorios > 0;
      this.buscaAvancadaFilter.quartos = temDormitorios ? [this.dormitorios + ''] : undefined;

      //garagens
      const temVagas = this.vagas && this.vagas > 0;
      this.buscaAvancadaFilter['garagem.gte'] = temVagas ? this.vagas : null;
      this.buscaAvancadaFilter['garagem.lte'] = temVagas ? 100 : null;

      //banheiros
      const temBanheiros = this.banheiros && this.banheiros > 0;
      this.buscaAvancadaFilter['banheiro.gte'] = temBanheiros ? this.banheiros : null;
      this.buscaAvancadaFilter['banheiro.lte'] = temBanheiros ? 100 : null;

      this.buscaAvancadaFilter.suites = this.suites && this.suites > 0 ? this.suites : null;

      if (this.selectedMobiliado !== null) {
         this.buscaAvancadaFilter.mobilia = this.selectedMobiliado ? [1] : [0];
      }

      if (this.selectedFinanciamento !== null) {
         this.buscaAvancadaFilter.financiavel = this.selectedFinanciamento ? '1' : '0';
      }

      if (this.selectedListaTag && this.selectedListaTag.length > 0) {
         this.buscaAvancadaFilter.tags = [this.selectedListaTag];
      } else {
         this.buscaAvancadaFilter.tags = [];
      }

      const comodidades: string[] = this.caracteristicas.filter((c) => c.checked).map((c) => c.name);
      this.buscaAvancadaFilter.comodidades = comodidades;

      if (this.selectedBairrosNomes && this.selectedBairrosNomes.length > 0) {
         this.buscaAvancadaFilter.bairros = this.selectedBairrosNomes;
      } else {
         this.buscaAvancadaFilter.bairros = [];
      }

      if (this.searchCod) {
         this.buscaAvancadaFilter.keywords = this.searchCod;
      } else {
         this.buscaAvancadaFilter.keywords = undefined;
      }

      if (hideMenu) {
         this.toggleFilterOverlay();
      }

      this.atualizarQueryParamsComFiltro(this.buscaAvancadaFilter);
   }

   private buscaPorCodigos() {
      console.log('buscaPorCodigos');
      const codigos = this.searchCod
         .split(',')
         .map((i) => i.trim())
         .filter((i) => i !== '');
      this.buscaAvancadaFilter = resetBuscaAvancadaFilter();
      this.buscaAvancadaFilter.pageSize = 1;
      this.buscaAvancadaFilter.codigos = codigos;

      this.atualizarQueryParamsComFiltro(this.buscaAvancadaFilter);
   }

   async buscarImoveis() {
      if (this.buscaAvancadaFilter) {
         this.isLoading = true;

         this.buscaAvancadaFilter.sortby = this.sort;
         this.buscaAvancadaFilter.pageSize = 16;
         this.buscaAvancadaFilter.captador = this.codigoCaptador > 0 ? this.codigoCaptador : undefined;

         const buscaSub = this.buscaService.fetch(this.buscaAvancadaFilter).subscribe({
            next: (res) => {
               const { items, total } = res;
               this.buscaResponse = res;

               this.quantidade2 = total ?? 0;
               if (items.length === 0) {
                  this.imoveis2 = [];
                  this.message = 'Nenhum resultado encontrado';
               } else {
                  this.imoveis2 = items;
                  this.message = null;
               }
               this.refreshMarcadores();
            },
            error: console.error,
            complete: () => (this.isLoading = false)
         });

         this.subscriptions.push(buscaSub);
      }
   }

   onSearchChange(value: string): void {
      console.log({ value });
      if (value.length < 3) {
         this.tips = [];
      }
      this.searchSubject.next(value);
   }

   mobile: boolean = false;
   checkMobile() {
      if (typeof window !== 'undefined') {
         this.mobile = window.innerWidth < 935;
      }
   }
   // ✅ Abre e fecha o dropdown mantendo o estado
   toggleDropdownTip(event: Event) {
      event.stopPropagation();
      this.dropdownOpenTip = !this.dropdownOpenTip;
   }

   // ✅ Alterna a seleção dos tipos de imóvel (checkbox)
   toggleSelectionTip(index: number) {
      this.subTipos[index].checked = !this.subTipos[index].checked;
      this.updateSubtipoString();
   }

   // ✅ Mantém o dropdown aberto ao clicar no input
   keepDropdownOpen(event: Event) {
      event.stopPropagation();
      this.dropdownOpenBairro = true;
   }

   isCodigo: boolean = false;
   checkCod() {
      this.isCodigo = !this.isCodigo;
      this.searchCod = this.isCodigo ? '' : this.searchCod;
      this.searchTextBairro = this.isCodigo ? '' : this.searchTextBairro;
   }

   stopPropagation(event: Event) {
      event.stopPropagation(); // Impede que o clique no select feche o dropdown
   }

   // ✅ Fecha dropdowns ao clicar fora, mas mantém select nativo funcional
   @HostListener('document:click', ['$event'])
   fecharDropdownFora(event: Event) {
      const targetElement = event.target as HTMLElement;

      // ⚠️ Verifica se o clique foi dentro de um select nativo
      if (targetElement.tagName.toLowerCase() === 'select') {
         return;
      }

      // ⚠️ Verifica se o clique foi dentro de qualquer dropdown
      if (targetElement.closest('.select-wrapper') || targetElement.closest('.select-campo-filtro')) {
         return;
      }

      // ❌ Fecha todos os dropdowns
      this.closeAllDropdowns();
   }

   carregarScriptGoogleMaps(): void {
      if (typeof document !== 'undefined') {
         if (document.getElementById('google-maps-script')) {
            this.initMap();
            return;
         }
         if (typeof document !== 'undefined') {
            const script = document.createElement('script');
            script.id = 'google-maps-script';
            script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}`;
            script.async = true;
            script.defer = true;
            script.onload = () => this.initMap();
            document.body.appendChild(script);
         }
      }
   }

   initMap(): void {
      try {
         if (typeof document !== 'undefined') {
            this.map = new google.maps.Map(document.getElementById('map'), {
               mapTypeControl: false,
               streetViewControl: false,
               gestureHandling: 'greedy', // Permite zoom normal sem CTRL + Scroll
               disableDefaultUI: false // Mantém os controles padrões do Google Maps
            });

            // Cria o botão de fechar
            const closeButton = document.createElement('div');
            closeButton.style.backgroundColor = '#e53935'; // Vermelho
            closeButton.style.color = '#fff';
            closeButton.style.fontWeight = 'bold';
            closeButton.style.border = 'none';
            closeButton.style.borderRadius = '4px';
            closeButton.style.boxShadow = '0 2px 6px rgba(0,0,0,0.3)';
            closeButton.style.cursor = 'pointer';
            closeButton.style.margin = '10px';
            closeButton.style.padding = '8px 14px';
            closeButton.style.fontSize = '14px';
            closeButton.style.transition = 'background-color 0.3s';
            closeButton.innerText = '✕ Fechar mapa';

            // Define o que acontece ao clicar no botão
            closeButton.addEventListener('click', () => {
               const mapContainer = document.getElementById('map');
               if (mapContainer) {
                  this.toggleOverlay();
               }
            });

            this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(closeButton);
            this.refreshMarcadores();
         }
      } catch (e) {
         console.error(e);
      }
   }

   refreshMarcadores() {
      try {
         this.marcadores.forEach((m) => m.setMap(null));
         this.marcadores = [];

         if (this.map) {
            const bounds = new google.maps.LatLngBounds();

            this.imoveis2.forEach((local) => {
               const latLng = new google.maps.LatLng(local.latitude, local.longitude);
               bounds.extend(latLng);

               const marcador = this.adicionarMarcador(local);
               if (marcador) {
                  this.marcadores.push(marcador);
               }
            });

            // Garante que há pelo menos um marcador antes de chamar fitBounds
            if (this.imoveis2.length > 0) {
               setTimeout(() => {
                  this.map.fitBounds(bounds);

                  // Se o zoom ficar muito amplo, aplica um limite
                  const listener = google.maps.event.addListener(this.map, 'idle', () => {
                     if (this.map.getZoom() > 15) {
                        this.map.setZoom(15); // Define um zoom máximo para evitar um mapa muito afastado
                     }
                     google.maps.event.removeListener(listener);
                  });
               }, 500);
            }
         }
      } catch (e) {
         console.error(e);
      }
   }

   adicionarMarcador(local: ImovelResponseDto) {
      if (typeof document !== 'undefined') {
         const tamanhoAmpliado = new google.maps.Size(47, 47);
         const tamanhoNormal = new google.maps.Size(45, 45);
         const urlIcone = '../../assets/pin-cancian.png';

         const marcador = new google.maps.Marker({
            position: { lat: local.latitude, lng: local.longitude },
            map: this.map,
            title: local.titulo,
            icon: {
               url: urlIcone,
               scaledSize: tamanhoNormal
            }
         });

         // Efeito hover no marcador
         marcador.addListener('mouseover', () => {
            marcador.setIcon({
               url: urlIcone,
               scaledSize: tamanhoAmpliado
            });
         });

         marcador.addListener('mouseout', () => {
            marcador.setIcon({
               url: urlIcone,
               scaledSize: tamanhoNormal
            });
         });

         // Evento de clique para exibir o mini-card
         marcador.addListener('click', () => {
            // Centraliza o mapa na posição do marcador
            // this.map.setCenter(marcador.getPosition() as google.maps.LatLng);

            // Obtém as coordenadas do centro do mapa
            // const center = this.map.getProjection()?.fromLatLngToPoint(this.map.getCenter()!);

            const divElement = document.getElementById('info-div');
            if (divElement) {
               divElement.style.display = 'block';
               divElement.style.position = 'fixed';

               // Define o mini-card no centro do mapa
               divElement.style.right = `0%`;
               divElement.style.top = `50%`;
               divElement.style.transform = `translate(-50%, -50%)`;
               // Atualiza o conteúdo da div
               divElement.innerHTML = buildMapCardHTML(local);
               // Adiciona evento de clique ao botão para fechar a div
               if (typeof document !== 'undefined') {
                  document.getElementById('btn-fechar-info')?.addEventListener('click', () => {
                     divElement.style.display = 'none';
                  });
               }
               // Adiciona evento de clique ao mini-card para abrir imóvel
               divElement.querySelector('.mini-card')?.addEventListener('click', () => {
                  this.abreImovel(local.slug);
               });
            }
         });

         return marcador;
      }
   }

   limparFiltros() {
      this.tips = [];
      const { contrato, cidade, sortby } = this.buscaAvancadaFilter;

      this.selectedBanheiros = null;
      this.selectedVagas = null;
      this.selectedQuartos = null;
      this.selectedSuites = null;
      this.selectedFinalidade = 0; // Valor padrão definido inicialmente
      this.valorMinimo = null;
      this.valorMaximo = null;
      this.areaDe = null;
      this.areaAte = null;

      this.selectedBairros = [];
      this.selectedBairrosNomes = [];

      this.selectedOrdenacao = null;
      this.selectedCodigoCidade = 0;
      this.selectedCodigoRegiao = 0;
      this.selectedCodigoSubRegiao = 0;
      this.pageIndex = 1;

      this.selectedTiposNomes = [];
      this.subTipos.forEach((s) => (s.checked = false));

      this.atualizarQueryParamsComFiltro({
         contrato: contrato ?? 'Compra',
         cidade: cidade ?? undefined,
         sortby: sortby ?? 'd_date'
      });
   }

   abreImovel(idImovel: any): void {
      const url = this.router.serializeUrl(this.router.createUrlTree(['/imovel', idImovel]));
      window.open(url, '_blank'); // Abre em uma nova aba
   }

   isOverlayOpen = false;
   gridState: 'default' | 'filter-open' | 'overlay-opened' = 'default';
   toggleOverlay(): void {
      this.isOverlayOpen = !this.isOverlayOpen;
      this.gridState = this.isOverlayOpen ? 'overlay-opened' : 'default';
      if (this.isOverlayOpen) {
         if (typeof window !== 'undefined') {
            window.scrollBy({
               top: 300, // Ajuste esse valor para definir o quanto a página rolará
               behavior: 'smooth' // Faz a rolagem ser suave
            });
         }
      } else {
         this.fecharInfoDiv();
      }
      this.carregarScriptGoogleMaps();
   }

   fecharInfoDiv() {
      const divElement = document.getElementById('info-div');
      if (divElement) {
         divElement.style.display = 'none';
      }
   }

   isOverlayFilterOpen = false;
   toggleFilterOverlay(): void {
      this.isOverlayFilterOpen = !this.isOverlayFilterOpen;
      this.gridState = this.isOverlayFilterOpen ? 'filter-open' : 'default';
      this.isOverlayOpen = false;
   }

   pageIndex = 1;
   newPageIndex = 1;
   getPages(): number[] {
      const totalPaginas = this.buscaResponse?.totalPages;

      if (totalPaginas <= 1) return [1]; // Apenas uma página disponível

      const pagesArray: number[] = [];
      let maxPagesToShow = this.mobile ? 3 : 5; // Exibir menos páginas no mobile

      // Ajustar início e fim da paginação
      let startPage = Math.max(1, this.buscaResponse?.page - Math.floor(maxPagesToShow / 2));
      let endPage = Math.min(totalPaginas, startPage + maxPagesToShow - 1);

      // Ajuste quando estiver perto do final
      if (endPage - startPage < maxPagesToShow - 1) {
         startPage = Math.max(1, endPage - maxPagesToShow + 1);
      }

      // Criar o array de páginas
      for (let i = startPage; i <= endPage; i++) {
         pagesArray.push(i);
      }

      return pagesArray;
   }

   previousPage(): void {
      const currentPage = this.buscaResponse.page;

      if (currentPage > 0) {
         const page = currentPage - 1;
         this.navigateToPage(page);
      }
   }

   nextPage(): void {
      const page = this.buscaResponse.page + 1;
      this.navigateToPage(page);
   }

   navigateToPage(page: number): void {
      this.router.navigate([], {
         relativeTo: this.route,
         queryParams: { page },
         queryParamsHandling: 'merge' // mantém os outros parâmetros
      });
   }

   getSvgColor(): string {
      return this.buscaResponse?.page === 1 ? '#e0e0e0' : '#c70000';
   }

   getSvgColorEnd(): string {
      const totalPaginas = this.buscaResponse?.totalPages;
      return this.pageIndex === totalPaginas ? '#e0e0e0' : '#c70000';
   }

   dormitorios: number = 0;
   suites: number = 0;
   banheiros: number = 0;
   vagas: number = 0;
   increment(field: string): void {
      if (field === 'dormitorios') {
         this.dormitorios++;
         this.selectedQuartos = this.dormitorios.toString();
      }
      if (field === 'suites') {
         this.suites++;
         this.selectedSuites = this.suites.toString();
      }
      if (field === 'banheiros') {
         this.banheiros++;
         this.selectedBanheiros = this.banheiros.toString();
      }
      if (field === 'vagas') {
         this.vagas++;
         this.selectedVagas = this.vagas.toString();
      }
   }

   decrement(field: string): void {
      if (field === 'dormitorios' && this.dormitorios > 0) {
         this.dormitorios--;
         this.selectedQuartos = this.dormitorios.toString();
      }
      if (field === 'suites' && this.suites > 0) {
         this.suites--;
         this.selectedSuites = this.suites.toString();
      }
      if (field === 'banheiros' && this.banheiros > 0) {
         this.banheiros--;
         this.selectedBanheiros = this.banheiros.toString();
      }
      if (field === 'vagas' && this.vagas > 0) {
         this.vagas--;
         this.selectedVagas = this.vagas.toString();
      }
   }

   // isCodigo: boolean = false;
   toggleCodigo() {
      this.isCodigo = !this.isCodigo;

      // Atualizar o select quando o checkbox for marcado
      const selectElement = document.getElementById('duvida') as HTMLSelectElement;
      if (this.isCodigo) {
         selectElement.value = 'codigo'; // Define um valor especial
      } else {
         selectElement.value = '0'; // Volta ao estado inicial
      }
   }

   updateCheckbox(event: any) {
      this.isCodigo = event.target.value === 'codigo';
   }

   selectedCaracteristicas: string[] = []; // Lista de características selecionadas
   searchTextCarac: string = ''; // Texto de pesquisa para o filtro

   toggleDropdownCaracteristicas(event: Event) {
      event.stopPropagation();
      this.closeAllDropdowns();
      this.dropdownCaracteristicas = !this.dropdownCaracteristicas;
   }

   toggleSelectionCarac(name: string) {
      this.caracteristicas.forEach((c) => {
         if (c.name === name) {
            c.checked = !c.checked;
         }
      });
      this.updateselectedCaracteristicas();
   }

   updateselectedCaracteristicas() {
      this.selectedCaracteristicas = this.caracteristicas.filter((c) => c.checked).map((c) => c.name);
   }

   // 🔹 Filtrar características com base no texto digitado
   filteredCaracteristicas() {
      return this.caracteristicas.filter((c) => c.name.toLowerCase().includes(this.searchTextCarac.toLowerCase()));
   }

   isScrolled = false;
   @HostListener('window:scroll', [])
   onWindowScroll(): void {
      this.isScrolled = window.scrollY > 0;
      const overlay = document.querySelector('.overlay') as HTMLElement;
      if (!overlay) return;

      let scrollY = 0;
      scrollY = window.scrollY;

      // Se scrollY for 200 ou mais, top = 0
      // Caso contrário, mapeia linearmente de 50% (scrollY=0) até 0% (scrollY=200)
      const newTop = scrollY >= 200 ? 0 : 25 - (scrollY / 200) * 30;
      overlay.style.top = newTop + '%';
   }

   handleOrdenacao(value: string) {
      this.router.navigate([], {
         relativeTo: this.route,
         queryParams: { sortby: value },
         queryParamsHandling: 'merge' // mantém os outros parâmetros
      });
   }

   private updateSubtipoString() {
      this.selectedTiposNomes = this.subTipos.filter((s) => s.checked).map((s) => s.name);
   }

   private atualizarQueryParamsComFiltro(filtro: any) {
      this.router.navigate([], {
         relativeTo: this.route,
         queryParams: { ...filtro },
         queryParamsHandling: 'replace'
      });
   }

   get contratoIsCompra() {
      return this.buscaAvancadaFilter?.contrato === 'Compra';
   }

   get temValor() {
      const temValor =
         (this.valorMinimo || this.valorMaximo) &&
         (Number.parseFloat(this.valorMinimo) > 0 || Number.parseFloat(this.valorMaximo) > 0);
      return temValor;
   }

   get temArea() {
      const temArea = (this.areaDe || this.areaAte) && (this.areaDe > 0 || this.areaAte > 0);
      return temArea;
   }

   opcoesOrdenacao = [
      { lista: 'd_date', nome: 'Recentes' },
      { lista: 'a_price', nome: 'Menor valor' },
      { lista: 'd_price', nome: 'Maior valor' }
   ];

   dropdownCaracteristicas = false;
   dropdownOpenBairro = false;
   dropdownOpenValores = false;
   dropdownOpenDormitorios = false;
   dropdownOpenVagas = false;
   dropdownOpenMetros = false;
   dropdownOpenTip = false;
   dropdownOpencaracterisicas = false;

   // ✅ Fecha todos os dropdowns antes de abrir um específico
   closeAllDropdowns() {
      this.dropdownCaracteristicas = false;
      this.dropdownOpenBairro = false;
      this.dropdownOpenValores = false;
      this.dropdownOpenDormitorios = false;
      this.dropdownOpenVagas = false;
      this.dropdownOpenMetros = false;
      this.dropdownOpenTip = false;
   }

   // ✅ Alterna exibição do dropdown de valores
   toggleDropdownValores(event: Event) {
      event.stopPropagation();
      this.closeAllDropdowns();
      this.dropdownOpenValores = true;
   }

   // ✅ Alterna exibição do dropdown de dormitórios
   toggleDropdownDormitorios(event: Event) {
      event.stopPropagation();
      this.closeAllDropdowns();
      this.dropdownOpenDormitorios = true;
   }

   // ✅ Alterna exibição do dropdown de vagas
   toggleDropdownVagas(event: Event) {
      event.stopPropagation();
      this.closeAllDropdowns();
      this.dropdownOpenVagas = true;
   }

   // ✅ Alterna exibição do dropdown de metros
   toggleDropdownMetros(event: Event) {
      event.stopPropagation();
      this.closeAllDropdowns();
      this.dropdownOpenMetros = true;
   }

   // ✅ Exibir sugestões ao digitar
   filterOptionsBairro() {
      const search = this.searchTextBairro.toLowerCase();
      this.filteredBairros = this.BairrosDisponiveis.filter((bairro) =>
         `${bairro.nome}`.toLowerCase().includes(search)
      );
   }

   // ✅ Selecionar bairro ao clicar no dropdown
   toggleSelectionBairro(bairro: any) {
      const index = this.selectedBairrosNomes.indexOf(bairro.nome);

      if (index === -1) {
         // Adiciona bairro
         this.selectedBairrosNomes.push(bairro.nome);
      } else {
         // Remove bairro
         this.selectedBairrosNomes.splice(index, 1);
      }

      this.searchTextBairro = ''; // Limpar input após seleção
   }

   // ✅ Alterna exibição do dropdown de bairros
   toggleDropdownBairro(event: Event) {
      event.stopPropagation();
      this.closeAllDropdowns();
      this.dropdownOpenBairro = true;
   }

   // ✅ Verifica se o bairro já está selecionado
   isBairroSelected(nome: string): boolean {
      return this.selectedBairrosNomes.includes(nome);
   }

   removeBairro(nome: string) {
      const index = this.selectedBairrosNomes.indexOf(nome);
      if (index !== -1) {
         this.selectedBairros.splice(index, 1);
         this.selectedBairrosNomes.splice(index, 1);
      }
   }
   // ✅ Adicionar bairro ao pressionar ENTER ou vírgula
   addBairroFromInput() {
      const bairroEncontrado = this.BairrosDisponiveis.find(
         (b) => b.nome.toLowerCase() === this.searchTextBairro.trim().toLowerCase()
      );

      if (bairroEncontrado && !this.isBairroSelected(bairroEncontrado.nome)) {
         this.selectedBairros.push(bairroEncontrado.nome);
         this.selectedBairrosNomes.push(bairroEncontrado.nome);
      }

      this.searchTextBairro = ''; // Limpar input após adição
      this.filterOptionsBairro(); // Atualizar lista filtrada
   }

   removeLastBairro() {
      if (this.searchTextBairro === '' && this.selectedBairros.length > 0) {
         this.selectedBairros.pop();
         this.selectedBairrosNomes.pop();
      }
   }
}

